import React, { FC, memo, useState, useEffect } from "../../../lib/teact/teact";
import { LotScreenSettings } from "../config/uiconfig";
import { AdminApi } from "../restapi/adminApi";
import Loading from "../ui/loading";
import './agentlist.scss'

type OwnProps = {
    dataFilter: string;
    onChangeScreen: (data: any) => void;
}

const TreeView: FC<{
    data: any, dataFilter: string,
    onChangeScreen: (data: any) => void
}> = ({ data, dataFilter, onChangeScreen }) => {
    function getClass(role: string) {
        let cls = " user"
        switch (role) {
            case "admin_lv0":
                cls = " tong";
                break;
            case "admin_lv1":
                cls = " tong"
                break;
            case "admin_lv2":
                cls = " daily"
                break;
        }
        return cls;
    }
    function isAdmin(group: string) {
        const ret = group != "user" && group != "guest"
        return ret;
    }
    function isExpire(dateString: string): boolean {
        // Chuyển đổi chuỗi ngày thành đối tượng Date
        const inputDate = new Date(dateString);

        // Lấy ngày hiện tại
        const currentDate = new Date();

        // Đặt giờ, phút, giây và mili giây của ngày hiện tại về 0 để so sánh chính xác
        currentDate.setHours(0, 0, 0, 0);

        // So sánh ngày đầu vào với ngày hiện tại
        return inputDate < currentDate;
    }
    function formatDateToDDMM(dateString: string): string {
        // Chuyển đổi chuỗi ngày thành đối tượng Date
        const date = new Date(dateString);

        // Lấy ngày và tháng từ đối tượng Date
        const day = String(date.getDate()).padStart(2, '0');  // Đảm bảo ngày có 2 chữ số
        const month = String(date.getMonth() + 1).padStart(2, '0');  // Tháng cần cộng thêm 1 và đảm bảo có 2 chữ số

        // Trả về chuỗi định dạng dd/MM
        return `${day}/${month}`;
    }
    function formatDateToDDMMYY(dateString: string): string {
        // Chuyển đổi chuỗi ngày thành đối tượng Date
        const date = new Date(dateString);

        // Lấy ngày, tháng và năm từ đối tượng Date
        const day = String(date.getDate()).padStart(2, '0');  // Đảm bảo ngày có 2 chữ số
        const month = String(date.getMonth() + 1).padStart(2, '0');  // Tháng cần cộng thêm 1 và đảm bảo có 2 chữ số
        const year = String(date.getFullYear()).slice(-2);  // Lấy 2 chữ số cuối của năm

        // Trả về chuỗi định dạng dd/MM/yy
        return `${day}/${month}/${year}`;
    }
    const date = data.data.expDate.substring(0, 10)
    return (
        <>
            <li onClick={(e) => {
                e.stopPropagation()
                e.preventDefault()
                onChangeScreen(data)

            }}><span className={"user-name" + getClass(data.data.userGroupRole)}>{data.data.username}</span>
                {data.data.userGroupRole == "user" && !isExpire(date) && <span>{formatDateToDDMMYY(date)}</span>}
                <span>{isAdmin(data.data.userGroupRole) ?
                    ("(ton" + (data.capQuyen.cap - data.capQuyen.huy - data.capQuyen.thanhToan) + ")" +
                        'c:'+data.capQuyen.cap + "h:" + data.capQuyen.huy + "tt:" + data.capQuyen.thanhToan) :
                    ""}
                </span>
            </li>
            {data.children.length > 0 && (
                <ul>
                    {data.children.filter((item: any) => {
                        return item.path.toLowerCase().includes(dataFilter.toLowerCase())
                    }).map((child: any) => (
                        <TreeView key={child.data.userId} data={child} dataFilter={dataFilter}
                            onChangeScreen={onChangeScreen}
                        />
                    ))}
                </ul>
            )}
        </>

    );
};
const AgentList: FC<OwnProps> = ({
    dataFilter,
    onChangeScreen,
}) => {
    const [state, setState] = useState({
        userData: undefined,
        isLoading: true,

    })
    useEffect(() => {
        AdminApi.FetchUsers().then(result => {
            setState(prev => ({ ...prev, userData: result.data, isLoading: false }))
        })
    }, [])

    return (

        <div className=" form-content">
            <div className="main-tree">
                <div>
                    {
                        state.isLoading && <Loading />
                    }
                    {state.userData && <TreeView data={state.userData} dataFilter={dataFilter}
                        onChangeScreen={onChangeScreen} />
                    }
                </div>
            </div>
        </div>



    )
}

export default memo(AgentList)